module.exports = __webpack_public_path__ + "static/media/CD__0003_0001.90282071.png";